<template>
    <div class="login-title"
        :style="{
            color: colors.theme !== 'dark' ? '#000' : '#fff',
        }"    
    >
        {{ title }}
    </div>
</template>
<script>
export default {
    props: {
        title : {
            type : String,
            required :  true
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    }
}
</script>
<style lang="scss">
    .login-title{
        letter-spacing: 3px;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 30px;
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

